import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/header";
import Footer from "../../components/footer";
import AddNewDropdown from "../../components/AddNewResearch";
import AdminImg from "../../assets/admin.png";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UserProfile = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedTab, setSelectedTab] = useState("publications");
  const [isFollowing, setIsFollowing] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    const fetchCurrentUserAndCheckFollowing = async () => {
      try {
        const profileRes = await fetch(
          `${BASE_URL}/user/profile/create-profile/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );
        const profileData = await profileRes.json();
        const currentId = profileData?.data?.id;
        setCurrentUserId(currentId);
        if (currentId && currentId !== id) {
          const followRes = await axios.get(
            `${BASE_URL}/user/follow-unfollow/follow/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": process.env.REACT_APP_X_API_KEY
              },
            }
          );
          const followedUsers = followRes.data?.results || [];
          // const isFollowed = followedUsers.some(
          //   (user) => String(user.follow_user_profile?.id) === String(id)
          // );
          const isFollowed = followedUsers.some(
            (user) => String(user.follow_user_profile?.user) === String(id)
          );


          setIsFollowing(isFollowed);
        }
      } catch (err) {
        console.error("Error checking follow status", err);
      }
    };
    if (token) {
      fetchCurrentUserAndCheckFollowing();
    }
  }, [id, token]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/user/profile/all-profiles/?id=${id}`,
          {
            headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
          }
        );
        const data = await res.json();
        if (res.ok) {
          setProfile(data.data);
        } else {
          console.error("Failed to fetch user profile");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [id, token]);

  const handleFollowToggle = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_X_API_KEY
      };
      if (isFollowing) {
        const res = await axios.delete(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          {
            headers,
            data: { id },
          }
        );
        if (
          res.status === 204 ||
          res.data?.message === "Successfully unfollowed."
        ) {
          toast.success("Unfollowed successfully");
          setIsFollowing(false);
        }
      } else {
        const res = await axios.post(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          { id },
          { headers }
        );
        if (res.data?.message === "Successfully followed") {
          toast.success("Followed successfully");
          setIsFollowing(true);
        } else if (res.data?.error === "You are already following this user.") {
          toast.info("Already following");
          setIsFollowing(true);
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.error("Follow/Unfollow Error:", err);
    }
  };

  if (loading) {
    return (
      <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!profile) return <div>User not found.</div>;

  return (
   <>
  <Header />
  <div className="max-w-6xl mx-auto px-4 py-8">
    {/* Profile Header */}
    <div className="bg-white rounded-2xl border border-gray-200 p-6 mb-8 shadow-sm">
      <div className="flex flex-col md:flex-row gap-6">
        {/* Profile Image */}
        <div className="flex-shrink-0">
          <div className="relative">
            <img
              src={profile.profile_picture || AdminImg}
              alt={profile.name}
              className="w-32 h-32 rounded-2xl object-cover border-4 border-white shadow-lg"
            />
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
          </div>
        </div>

        {/* Profile Details */}
        <div className="flex-1">
          <div className="flex flex-wrap justify-between items-start gap-4">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">{profile.name}</h2>
              <div className="space-y-1">
                {profile.institution && (
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold text-gray-700">Institution:</span> {profile.institution}
                  </p>
                )}
                {profile.primary_affiliation && (
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold text-gray-700">Affiliation:</span> {profile.primary_affiliation}
                  </p>
                )}
                {profile.degree && (
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold text-gray-700">Degree:</span> {profile.degree}
                  </p>
                )}
                {profile.research_areas && (
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold text-gray-700">Research Areas:</span> {profile.research_areas}
                  </p>
                )}
                {profile.current_activity && (
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold text-gray-700">Activity:</span> {profile.current_activity}
                  </p>
                )}
                {profile.bio && (
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold text-gray-700">Bio:</span> {profile.bio}
                  </p>
                )}
              </div>
            </div>

            {currentUserId && String(currentUserId) !== String(id) && (
              <button
                className={`px-5 py-2.5 text-sm font-medium rounded-xl transition-colors ${
                  isFollowing
                    ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    : "bg-[#0f6abf] text-white hover:bg-[#0a5ca8]"
                }`}
                onClick={handleFollowToggle}
              >
                {isFollowing ? "Following" : "Follow"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Tabs Navigation */}
    <div className="flex gap-2 border-b border-gray-200 mb-6">
      {["publications", "gallery", "videos", "code", "portfolio"].map(
        (tab) => (
          <button
            key={tab}
            className={`px-4 py-2.5 text-sm font-medium transition-all ${
              selectedTab === tab
                ? "text-[#0f6abf] border-b-2 border-[#0f6abf]"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        )
      )}
    </div>

    {/* Tab Content */}
    <div className="mt-6">
      {/* Publications */}
      {selectedTab === "publications" && (
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-lg font-semibold text-gray-900">Publications</h3>
          </div>
          <div className="space-y-3">
            {profile.publications.map((pub) => (
              <div key={pub.id} className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                <p className="text-sm text-gray-800">{pub.title}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Gallery */}
      {selectedTab === "gallery" && (
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-lg font-semibold text-gray-900">Gallery</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {profile.gallery_images.map((img) => (
              <img
                key={img.id}
                src={img.image}
                alt="Gallery"
                className="w-full h-40 object-cover rounded-xl border border-gray-200"
              />
            ))}
          </div>
        </div>
      )}

      {/* Videos */}
      {selectedTab === "videos" && (
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-lg font-semibold text-gray-900">Videos</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {profile.videos.map((video) => (
              <video
                key={video.id}
                controls
                className="w-full rounded-xl border border-gray-200"
              >
                <source src={video.video} type="video/mp4" />
              </video>
            ))}
          </div>
        </div>
      )}

      {/* Code Contributions */}
      {selectedTab === "code" && (
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-lg font-semibold text-gray-900">Code Contributions</h3>
          </div>
          <div className="space-y-4">
            {profile.user_codes.map((code) => (
              <div key={code.id} className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                <p className="text-sm font-medium text-gray-900 mb-2">
                  <strong>{code.title}</strong> ({code.code_of})
                </p>
                <pre className="text-sm text-gray-700 overflow-x-auto bg-gray-900 text-gray-100 p-4 rounded-lg">{code.code}</pre>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Portfolio */}
      {selectedTab === "portfolio" && (
        <div className="space-y-6">
          {/* Internships */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <h3 className="text-lg font-semibold text-gray-900">Internships</h3>
            </div>
            <div className="space-y-4">
              {profile.internships.map((intern) => (
                <div key={intern.id} className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  <p className="text-sm font-semibold text-gray-900">
                    {intern.title} at {intern.company}
                  </p>
                  <p className="text-sm text-gray-600 mt-1">
                    {intern.start_month} {intern.start_year} – {intern.end_month} {intern.end_year}
                  </p>
                  <p className="text-sm text-gray-700 mt-2">{intern.description}</p>
                  <a
                    href={intern.media}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-3 text-sm text-[#0f6abf] hover:underline"
                  >
                    View Certificate
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Projects */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <h3 className="text-lg font-semibold text-gray-900">Projects</h3>
            </div>
            <div className="space-y-4">
              {profile.projects.map((project) => (
                <div key={project.id} className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  <p className="text-sm font-semibold text-gray-900">
                    {project.project_name}
                  </p>
                  <p className="text-sm text-gray-700 mt-2">{project.description}</p>
                  <p className="text-sm text-gray-600 mt-2">
                    <strong>Skills:</strong> {project.skills}
                  </p>
                  <a
                    href={project.media}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-3 text-sm text-[#0f6abf] hover:underline"
                  >
                    View File
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Education */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <h3 className="text-lg font-semibold text-gray-900">Education</h3>
            </div>
            <div className="space-y-4">
              {profile.education.map((edu) => (
                <div key={edu.id} className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  <p className="text-sm font-semibold text-gray-900">
                    {edu.school} - {edu.degree}
                  </p>
                  <p className="text-sm text-gray-600 mt-1">
                    {edu.start_Year} to {edu.end_Year}
                  </p>
                  <p className="text-sm text-gray-600 mt-1">
                    {edu.field_study} | Grade: {edu.grade}
                  </p>
                  <p className="text-sm text-gray-700 mt-2">{edu.description}</p>
                  <a
                    href={edu.media}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-3 text-sm text-[#0f6abf] hover:underline"
                  >
                    View Doc
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
  <Footer />
</>
  );
};

export default UserProfile;
